import React, { useRef, useState } from 'react'
import { useRouter } from 'next/router'
import fetch from 'isomorphic-unfetch'

const DEFAULT_MESSAGE = {
  en: "We'll only send emails when something big happens. No spam.",
  tr: 'Yalnızca önemli bir şey olduğunda e-posta göndeririz. Spam yok.',
}

const THANKS_MESSAGE = {
  en: 'Thanks for subscribing!',
  tr: 'Abone olduğunuz için teşekkürler!',
}

const EMAIL_LABEL = {
  en: 'Email Address',
  tr: 'E-posta Adresi',
}

const SUBMIT_LABEL = {
  en: 'Submit →',
  tr: 'Gönder →',
}

// Rendered inside the dark footer (bg-surface-inverse), styled for that context.
export default function NewsletterSubscribeForm() {
  const { locale } = useRouter()
  const lang = locale === 'tr' ? 'tr' : 'en'
  const inputEl = useRef<HTMLInputElement>(null)
  const [message, setMessage] = useState<string>(DEFAULT_MESSAGE[lang])
  const [isError, setIsError] = useState(false)

  const clearField = () => {
    if (message !== DEFAULT_MESSAGE[lang]) {
      setMessage(DEFAULT_MESSAGE[lang])
      setIsError(false)
    }
  }

  const subscribeUser = async (e: React.SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()

    const res = await fetch('/api/subscribe', {
      body: JSON.stringify({
        email: inputEl.current?.value,
      }),
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
    })

    const { error } = await res.json()

    if (error) {
      console.error(error)
      setIsError(true)
      setMessage(error)
      return
    }

    setIsError(false)
    if (inputEl.current) {
      inputEl.current.value = ''
    }
    setMessage(THANKS_MESSAGE[lang])
  }

  return (
    <div className="flex flex-col gap-2">
      <form
        onSubmit={subscribeUser}
        className="flex flex-col gap-2 sm:flex-row sm:items-stretch"
      >
        <label htmlFor="email-input" hidden>
          {EMAIL_LABEL[lang]}
        </label>
        <input
          id="email-input"
          name="email"
          onChange={clearField}
          placeholder="you@your-company.com"
          ref={inputEl}
          required
          type="email"
          className="w-full flex-grow rounded-xl border border-white/20 bg-white/5 px-4 py-2.5 text-body-sm text-white placeholder:text-brand-200/60 focus:border-white/40 focus:outline-none focus:ring-2 focus:ring-white/20"
        />
        <button
          type="submit"
          className="flex-shrink-0 whitespace-nowrap rounded-xl bg-white px-5 py-2.5 text-body-sm font-medium text-brand-900 transition hover:bg-brand-100"
        >
          {SUBMIT_LABEL[lang]}
        </button>
      </form>
      <div
        className={`text-right text-caption ${
          isError ? 'text-[#fca5a5]' : 'text-brand-200/90'
        }`}
      >
        {message}
      </div>
    </div>
  )
}
